import { ColumnConfig } from '../column-config';
import { StoreColumnExtractor } from '../extractors/store-column-extractor';
import { SeriesMapper } from '../series-mappers/series-mapper.interface';
import { TableDataTransform } from '../table-data-transform/table-data-transform';
import { ExtractorConfig } from './extractor-config';

export abstract class SeriesExtractionExtractorConfig extends ExtractorConfig {
	constructor(
		portfolioName: ColumnConfig<StoreColumnExtractor>,
		public readonly mapper: SeriesMapper,
		public readonly childMapper?: (parent: any) => any[],
		TableDataTransform?: TableDataTransform
	) {
		super(portfolioName, TableDataTransform);
	}
}
